// extracted by mini-css-extract-plugin
export default {"contentWrapper":"GeneratedContent_contentWrapper__7FPGl"};